/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const patientList=usersList.injectEndpoints({
    tagTypes:['Patient','SelectedSubdivPatient','PatientMonitorUser','AssociatedObserverToPatient','PatientHistoryExport','AssociatedMonitorToPatient','AssociatedProviderToPatient','PatientActivityHistory'],
    endpoints:(builder)=>({
        getPatients: builder.query({
            query: (searchParams) => `patients?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'Patient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Patient', id:_id}))
            ]:[]

            
        }),
        addPatient:builder.mutation({
            query:org=>({
                url:`/patients/`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['Patient','PatientActivityHistory']
        }),
        getPatientSubdivisions:builder.query({
            query: (searchParams) => `organizations/list-subdivisions?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'SelectedSubdivPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'SelectedOrg', id:_id}))
            ]:[], 
        }),

        getPatient:builder.query({
            query:(id)=>`/patients/${id}`,
            providesTags:(result,error,arg)=>[{type:'Patient',id:arg}]
        }),
        viewPatient:builder.query({
            query:(id)=>`/patients/${id}`,
            
            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
           
           
        }),
        editPatient:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/patients/${id}`:`/patients/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags:(result,error,arg)=>[{type:'Patient',id:arg.id},'PatientActivityHistory']
        }),
        
        exportPatientsList:builder.mutation({
            query:({queryString,columns,dateformat})=>({
                url:`patients/export-list?${queryString}`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
        }),
        getPatientViewExportHistory: builder.query({
            query: (searchParams) => `patients/list-export-history?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'PatientHistoryExport']:[],
        }),

        linkMonitortoPatient: builder.mutation({
            query: ({patient_id,body}) => ({
                url: `patients/link-monitor-users/${patient_id}`,
                method: 'POST',
                body:body
            }),
            invalidatesTags: ['AssociatedMonitorToPatient','PatientActivityHistory']
        }),
        linkProvidertoPatient: builder.mutation({
            query: ({patient_id,body}) => ({
                url: `patients/link-providers/${patient_id}`,
                method: 'POST',
                body:body
            }),
            invalidatesTags: ['AssociatedProviderToPatient','PatientActivityHistory']
        }),
        linkObservertoPatient: builder.mutation({
            query: ({patient_id,body}) => ({
                url: `patients/link-observers/${patient_id}`,
                method: 'POST',
                body:body
            }),
            invalidatesTags: ['AssociatedObserverToPatient','PatientActivityHistory']
        }),

        getMonitorAssociatedToPatientList: builder.query({
            query: (searchParams) => `patients/list-linked-monitor-users?patient_id=${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedMonitorToPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({patient_id})=>({type:'AssociatedMonitorToPatient', id:patient_id}))
            ]:[],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        getProviderAssociatedToPatientList: builder.query({
            query: (searchParams) => `patients/list-linked-providers?patient_id=${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedProviderToPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({patient_id})=>({type:'AssociatedProviderToPatient', id:patient_id}))
            ]:[],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        getObserversAssociatedToPatientList: builder.query({
            query: (searchParams) => `patients/list-linked-observers/${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedObserverToPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({patient_id})=>({type:'AssociatedObserverToPatient', id:patient_id}))
            ]:[],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        
        deleteObserverAssociatedToPatient: builder.mutation({
            query: ({patient_id,observer_id}) => {
                return {
                    url: `patients/unlink-observers/${patient_id}?observer_id=${observer_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'AssociatedObserverToPatient', id: arg.patient_id },'PatientActivityHistory'],
        }),

        deleteMonitorAssociatedToPatient: builder.mutation({
            query: ({patient_id,monitor_id}) => {
                return {
                    url: `patients/unlink-monitor-users/${patient_id}?monitor_user_id=${monitor_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'AssociatedMonitorToPatient', id: arg.patient_id },'PatientActivityHistory'],
        }),
        addNotes:builder.mutation({
            query:org=>({
                url:`/patients/add-notes`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['Patient','PatientActivityHistory']
        }),
        deleteProviderAssociatedToPatient: builder.mutation({
            query: ({patient_id,provider_id}) => {
                return {
                    url: `patients/unlink-provider/${patient_id}?provider_id=${provider_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'AssociatedProviderToPatient', id: arg.patient_id },'PatientActivityHistory'],
        }),

        updateMonitorPermission:builder.mutation({
            query: ({patient_id,body}) => {
                return {
                    url: `patients/update-monitor-permission/${patient_id}`,
                    method: 'PATCH',
                    body:body
                };
            },
            invalidatesTags:  ['AssociatedMonitorToPatient','PatientActivityHistory'],

        }),
        associtateTemplateToPatient:builder.mutation({
            query: (body) => {
                return {
                    url: `patients/link-monitoring-template`,
                    method: 'POST',
                    body:body
                };
            },
        }),
        patientActivityHistoryList: builder.query({
            query: (searchParams) => `patients/list-changes?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'PatientActivityHistory']:[],
    
        }), 
        exportPatientExportLog:builder.mutation({
            query:({columns,dateformat,username})=>({
                url:`patients/export-history`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone,"target_user":username}
            }),
            invalidatesTags:['PatientActivityHistory']
        }),
        exportPatientActivityHistory:builder.mutation({
            query:({sort,columns,username,dateformat ,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return{
                    url:`patients/export-profile-changes?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"target_user_name":username,"dateformat":dateformat, "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
            invalidatesTags:['PatientHistoryExport']
        }),
        exportPatientNotes:builder.mutation({
            query:({dateformat,patientId,noteType})=>({
                url:`patients/export-note/${patientId}?note_type=${noteType}`,
                method:'POST',
                body:{"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone,}
            }),
        }),  
        viewWellnessNotes:builder.query({
            query:({id})=>({
                url:`/patients/list-wellness-note?patient_id=${id}&type=wellness-note`,
                method:'POST',
            }),
            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
            invalidatesTags:['PatientActivityHistory']
        }),
        patientVitalChangeHistoryList: builder.query({
            query: (searchParams) => `patients/list-changes?${searchParams}`,
            providesTags: ['PatientActivityHistory']
    
        }), 
        exportPatientVitalActivityHistory:builder.mutation({
            query:({sort,columns,username,dateformat ,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return{
                    url:`patients/export-vital-changes?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"target_user_name":username,"dateformat":dateformat, "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
       
        providerPreferenceChange:builder.mutation({
            query:({body})=>({
                url:`/patients/update_preference`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags:['Patient']
        }),
        updatePatientAlerts:builder.mutation({
            query:({patient_id,body})=>({
                url:`/providers/patients/${patient_id}/alerts`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags:['AssociatedMonitorPatient','AssociatedProviderPatient']
        }),
        getPatientWellnessDetails: builder.query({
            query: (patientId) => `patients/vital-data?patient_id=${patientId}`,
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),  
        VitalReadingList: builder.query({
            query: (searchParams) => `providers/list-historical-readings?${searchParams}`,
            providesTags: ['PatientActivityHistory']
    
        }), 
        exportDeviceVitalReadingList:builder.mutation({
            query:({columns,dateformat ,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return{
                    url:`patients/historical-data?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"dateformat":dateformat, "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        transferFile:builder.mutation({
            query:org=>({
                url:`/transfer-file`,
                method:'POST',
                body:org
            }),
        }),
        ActivityHistoryFileTransfer:builder.mutation({
            query:org=>({
                url:`users/record-activity`,
                method:'POST',
                body:org
            }),
        }),
        // helpguide
        getHelpGuideAdmin: builder.query({
            query: (queryParams) => ({
                url: `users/help-guides?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
    }),
    overrideExisting: false
})


export const {
    useAddPatientMutation,  
    useLazyGetPatientSubdivisionsQuery,
    useLazyGetPatientQuery,
    useViewPatientQuery,
    useEditPatientMutation,
    useGetPatientsQuery,
    useAssocitateTemplateToPatientMutation,
    useExportPatientsListMutation,
    useLinkProvidertoPatientMutation,
    useLinkObservertoPatientMutation,
    useLinkMonitortoPatientMutation,
    useGetMonitorAssociatedToPatientListQuery,
    useGetObserversAssociatedToPatientListQuery,
    useLazyGetMonitorAssociatedToPatientListQuery,
    useLazyGetProviderAssociatedToPatientListQuery,
    useLazyGetObserversAssociatedToPatientListQuery,
    useDeleteMonitorAssociatedToPatientMutation,
    useDeleteProviderAssociatedToPatientMutation,
    useDeleteObserverAssociatedToPatientMutation,
    useUpdateMonitorPermissionMutation,
    useAddNotesMutation,
    useGetProviderAssociatedToPatientListQuery,
    usePatientActivityHistoryListQuery,
    useExportPatientActivityHistoryMutation,
    useGetPatientViewExportHistoryQuery,
    useExportPatientExportLogMutation,
    useExportPatientNotesMutation,
    useViewWellnessNotesQuery,
    usePatientVitalChangeHistoryListQuery,
    useExportPatientVitalActivityHistoryMutation,
    useProviderPreferenceChangeMutation,
    useGetPatientWellnessDetailsQuery,
    useVitalReadingListQuery,
    useExportDeviceVitalReadingListMutation,
    useLazyViewPatientQuery,
    useTransferFileMutation,
    useActivityHistoryFileTransferMutation,
    useGetHelpGuideAdminQuery,
    useUpdatePatientAlertsMutation,

}=patientList